import htmx from "htmx.org";
import { useEffect, useRef } from "react";
import { CSRF } from "../header/util";
import { useAccount } from "../state";
import { WhitePage } from "./util";

// htmx 4 wisselt ook 4xx/5xx-antwoorden in; htmx 2 deed dat niet. Een 403
// (verlopen CSRF-token) zou het formulier dan vervangen door een pagina zonder
// #ca-login-form, dus het formulier verdwijnt. Terug naar het htmx 2-gedrag.
// De patronen "4xx"/"5xx" werken (htmx vergelijkt als tekst), alleen de
// typedeclaratie zegt number[].
htmx.config.noSwap = [204, 304, "4xx", "5xx"] as unknown as number[];

const Form = ({ url }) => {
  // const [form, setForm] = useState(EMPTY);
  const ref = useRef(undefined);
  useEffect(() => {
    if (!ref.current) return;
    const method = async () => {
      const response = (await fetch(url).catch(console.error)) || null;
      let text = "<div>Error</div>";
      if (response?.ok) text = await response.text();
      if (ref.current) {
        // @ts-ignore
        ref.current.innerHTML = text;
        htmx.process(ref.current);
      }
    };
    method().catch(console.error);
  }, [url, ref]);

  return <div ref={ref} />;
};

export const Login = () => {
  const user = useAccount();

  if (!user.user) {
    return (
      <WhitePage>
        <Form url="/auth/login/" />
      </WhitePage>
    );
  }

  return (
    <WhitePage>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Ingelogd
          </h2>
          <div className="mt-6 text-center">Ingelogd als {user.user.username}</div>
          <form method="post" action="/auth/logout/">
            {/* Full page reload */}
            <CSRF />
            <button
              type="submit"
              className="group relative flex w-full justify-center rounded-md border border-transparent bg-green py-2 px-4 text-sm font-medium text-white hover:bg-dark-green focus:outline-none focus:ring-2 focus:ring-green focus:ring-offset-2"
            >
              Logout
            </button>
          </form>
        </div>
      </div>
    </WhitePage>
  );
};
